import { dateUtils, formatNumber, formatDuration } from '@emartech/ui-framework-utils';
import purifier from '../../../../../utils/dom-purify.js';

const formatAsString = value => {
  if (value === 0) { return '0'; };
  return value ? value.toString() : '';
};

const formatAsCurrency = (precision, currency, humanize, language, style) => {
  return formatNumber({ precision, humanize, style, currency: currency || 'EUR', language });
};

const formatAsTime = (value, formatType, formats) => {
  return dateUtils.formatByName(value, formatType, formats);
};

const getFormatter = (formats, column, language) => {
  if (column.type === 'number') {
    return formatNumber({ precision: column.precision, style: 'decimal', humanize: column.humanize, language });
  } else if (column.type === 'percent') {
    return formatNumber({ precision: column.precision, style: 'percent' });
  } else if (['currency', 'currency-code'].includes(column.type)) {
    return formatAsCurrency(column.precision, column.currency, column.humanize, language, column.type);
  } else if (column.type === 'time') {
    return value => formatAsTime(value, column.format, formats);
  } else if (column.type === 'duration') {
    return value => formatDuration(value, { pad: true, showZeroParts: true, precision: column.precision, language });
  } else {
    return value => value;
  }
};

const formatColumn = (formats, language) => (content, column) => {
  const format = getFormatter(formats, column, language);
  content.forEach(row => {
    row.formatted[column.contentKey] = formatAsString(format(row.raw[column.contentKey]));

    if (!column.renderHtml) { return; }

    row.formatted[column.contentKey] = purifier.sanitize(
      row.formatted[column.contentKey],
      { ALLOW_UNKNOWN_PROTOCOLS: true }
    );
  });

  return content;
};

const format = (content, [language, columnDefinitions, formats]) => {
  const newContent = content.map(({ raw }) => ({ raw, formatted: Object.assign({}, raw) }));
  return columnDefinitions.reduce(formatColumn(formats, language), newContent);
};

export default format;
